import script from "./FloorModel3D.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorModel3D.vue?vue&type=script&setup=true&lang=js"

import "./FloorModel3D.vue?vue&type=style&index=0&id=21487714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21487714"]])

export default __exports__